import React from 'react';
import { useAppDispatch } from 'hooks';

import { faEye } from '~components/icon';
import { ClickableIcon } from '~components/index';

import { focusWorker } from '~weekly-planner/reducers/weeklyPlanner';

interface WorkerFocusActionProps {
  userId: string;
  className?: string;
}

const WorkerFocusAction: React.FC<WorkerFocusActionProps> = ({ userId, className = 'text-center' }) => {
  const dispatch = useAppDispatch();
  return (
    <div className={className}>
      <ClickableIcon
        id={`view-worker-${userId}`}
        dataCy={`view-worker-${userId}`}
        icon={faEye}
        toolTip="Focus Worker"
        onClick={() => dispatch(focusWorker(userId))}
        size="small"
      />
    </div>
  );
};

export default WorkerFocusAction;
